export type Fonts = {
  text_font: string;
  header2_font: string;
  learn_more_font: string;
  small_header: string;
  top_small_header: string;
}

export const fonts:Fonts = {
  text_font: 'normal normal normal 18px/1.4em arial,\'ｍｓ ｐゴシック\',\'ms pgothic\',\'돋움\',dotum,helvetica,sans-serif',
  header2_font: 'normal normal bold 30px/1.4em \'josefin slab\',serif',
  learn_more_font: 'normal normal bold 23px/1.4em \'josefin slab\',serif',
  small_header: 'normal normal normal 70px/1.4em \'josefin slab\',serif',
  top_small_header: 'normal normal normal arial,ms pgothic,dotum,helvetica,sans-serif',
};